import { IconButton } from 'office-ui-fabric-react';
import React from 'react';

const defaultCreateDuplicate = item => ({ ...item });

/**
 *
 * @param {(function(item, index):{})} getDuplicate
 * @returns {{getRenderer: (function(*): function(*, *): *), name: string, styles: {root: {visibility: string}}, key: string, maxWidth: number}}
 */
export const menuColumn = (getDuplicate = defaultCreateDuplicate) => ({
  key: 'menu',
  name: 'Menu',
  maxWidth: 20,
  styles: { root: { visibility: 'hidden' } },
  getRenderer: arrayHelpers => (item, index) =>
    (
      <IconButton
        iconProps={{ iconName: 'More' }}
        title="Options"
        ariaLabel="Options"
        onRenderMenuIcon={() => null}
        menuProps={{
          shouldFocusOnMount: false,
          items: [
            {
              key: 'duplicate',
              text: 'Duplicate',
              onClick: () => arrayHelpers.insert(index + 1, getDuplicate(item)),
            },
            {
              key: 'delete',
              text: 'Delete',
              onClick: () => arrayHelpers.remove(index),
            },
          ],
        }}
      />
    ),
});
